import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette } from '../../../theme';

const useStyles = (isPrimary) =>
  makeStyles((theme: Theme) =>
    createStyles({
      button: {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: 1,
        borderRadius: '999em',
        boxShadow: 'none',
        border: '3px solid #7EFCF0',
        background: isPrimary ? 'transparent' : colorsPalette.whiteSecondary,
        padding: 0,
        transition: '0.3s ease all',
        '& a': {
          textDecoration: 'none',
          padding: '16px 32px',
          color: colorsPalette.white,
        },
        '&:hover': {
          boxShadow: `0px 3px 6px ${colorsPalette.black}`,
          background: isPrimary ? theme.palette.primary.main : colorsPalette.whiteSecondary,
          marginBottom: 1,
          marginTop: -1,
          color: 'rgba(0, 0, 0, 0.87)',
        },
        '& a:hover': {
          color: 'rgba(0, 0, 0, 0.87)',
        },
        [theme.breakpoints.up('sm')]: {
          fontSize: 16,
          padding: 0,
        },
      },
    }),
  );
export default useStyles;
